import theme from './theme';

// Map theme keys to CSS custom properties on :root
export function applyThemeToRoot(t = theme) {
  const vars = {
    /* Colors */
    '--cq-color-primary': t.colors.primary,
    '--cq-color-primary-light': t.colors.primaryLight,
    '--cq-color-primary-dark': t.colors.primaryDark,
    '--cq-color-primary-glow': t.colors.primaryGlow,

    '--cq-color-secondary': t.colors.secondary,
    '--cq-color-surface': t.colors.surface,
    '--cq-color-bg': t.colors.bg,
    '--cq-color-border': t.colors.border,
    '--cq-color-text': t.colors.text,
    '--cq-color-text-secondary': t.colors.textSecondary,
    '--cq-color-success': t.colors.success,
    '--cq-color-warning': t.colors.warning,
    '--cq-color-danger': t.colors.danger,

    /* Typography */
    '--cq-font-family': t.typography.fontFamily,
    '--cq-font-mono': t.typography.fontFamilyMono,

    /* Spacing */
    '--cq-space-xs': t.spacing.xs,
    '--cq-space-sm': t.spacing.sm,
    '--cq-space-md': t.spacing.md,
    '--cq-space-lg': t.spacing.lg,

    /* Radius */
    '--cq-radius-sm': t.radius.sm,
    '--cq-radius-md': t.radius.md,
    '--cq-radius-lg': t.radius.lg,

    /* Shadows */
    '--cq-shadow-xs': t.shadows.xs,
    '--cq-shadow-md': t.shadows.md,
  };

  // Create or update a style tag with CSS variables
  const id = 'cq-theme-vars';
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('style');
    el.id = id;
    document.head.appendChild(el);
  }

  const lines = [':root {'];
  for (const k in vars) lines.push(`  ${k}: ${vars[k]};`);
  lines.push('}');
  el.textContent = lines.join('\n');
}

export default function initTheme() {
  try { applyThemeToRoot(); }
  catch (e) { console.error('Failed to apply clinic theme', e); }
}
